module.exports = __webpack_public_path__ + "img/aeroland-pricing-05-image-02.9a3b935d.png";